// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__cbb00b3d19731b73db3b","cls2":"SimplePaperPodcast-cls2___de89858009422310cb6 SimplePaperPodcast-cls1__cbb00b3d19731b73db3b"};